import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraTimeline } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { employerSectorVariant } from '../../badgeVariants';
import { registryHref } from '../../registryHref';
import { careerDateLabel } from './careerDateLabel';
const SECTOR_LABEL = {
    GOVERNMENT: 'Government',
    INDUSTRY: 'Industry',
    OURS: 'Ours'
};
function spanTitle(s) {
    const employer = s.employer?.name || s.employerText;
    if (s.title && employer) return `${s.title}, ${employer}`;
    return s.title || employer || 'Role not recorded';
}
/** Career, newest first. The row grows as sources name the person; it never resets. */ export function CareerTimeline({ career }) {
    const onlyFormRow = career.length === 1 && career[0]?.fromContactForm;
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Career · the row grows, it never resets"
            }),
            /*#__PURE__*/ _jsx(SpecraTimeline, {
                variant: "dated",
                renderLink: renderRouterLink,
                emptyText: "No jobs recorded yet.",
                getItemTestId: ()=>Testids.registryPerson.careerItem,
                items: career.map((s)=>{
                    const href = s.employer ? registryHref(s.employer) : null;
                    return {
                        id: s.id,
                        date: careerDateLabel(s),
                        badge: SECTOR_LABEL[s.sector] ? /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: employerSectorVariant(s.sector),
                            children: SECTOR_LABEL[s.sector]
                        }) : undefined,
                        title: spanTitle(s),
                        description: `Source: ${s.sourceText}`,
                        links: s.employer && href ? [
                            {
                                id: `${s.id}-employer`,
                                label: s.employer.name,
                                href
                            }
                        ] : undefined
                    };
                })
            }),
            onlyFormRow && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Earlier jobs appear here as documents and notices name this person."
            })
        ]
    });
}
